import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/loader/Loadable';
import Spinners from '../views/ui/Spinner';
import PrivateRoute from './PrivateRoute';
import Contacto from '../views/Contacto';
import RegistroCuentaWizard from '../views/app/registro/RegistroCuentaWizard';
import SimuladorCrecimiento from '../views/app/simulador/SimuladorCrecimiento';


/****Layouts*****/
const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/BlankLayout')));
/***** Pages ****/

const Starter = Loadable(lazy(() => import('../views/Starter')));
const EmpresaInfo = Loadable(lazy(() => import('../views/app/empresa/EmpresaInfo')));
const PrivacidadInfo = Loadable(lazy(() => import('../views/app/privacidad/PrivacidadInfo')));


/***** Auth Pages ****/
const Error = Loadable(lazy(() => import('../views/auth/Error')));
const Login = Loadable(lazy(() => import('../views/auth/Login')));
/*****Routes******/


const ThemeRoutes = [
  {
    path: '/',
    element: <Navigate to="/auth/login" />, // Redirige la raíz a la pagina principal
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '', element: <Navigate to="login" /> },
      { path: 'login', exact: true, element: <Login /> },
      { path: 'activarcuenta', element: <RegistroCuentaWizard /> },
      { path: 'simulador', element: <SimuladorCrecimiento /> }, // pública
      { path: '*', element: <Navigate to="404" /> },
    ],
  },
  {
    path: '/app',
    element: (
      <PrivateRoute>
        <FullLayout />
      </PrivateRoute>
    ),
    children: [
      { path: '', element: <Navigate to="starter" /> },
      { path: 'starter', element: <Starter /> },
      { path: 'contacto', element: <Contacto /> },
      { path: 'Spinners', element: <Spinners /> },
      { path: 'simulador', element: <SimuladorCrecimiento /> }, // privado
      { path: 'empresa', element: <EmpresaInfo /> },
      { path: 'privacidad', element: <PrivacidadInfo /> },

      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },

  // Redirect global: todo lo demás va a login
  { path: '/', element: <Navigate to="/app/starter" replace /> },
  { path: '*', element: <Navigate to="/auth/login" replace /> }
];

export default ThemeRoutes;
